export const LISTVIEW_LOCALE_ZHCHT = {
    emptyMessage: 'æ«ç¡æ¸æ',
    checkall: 'å¨é¸'
};
